<style lang="scss" scoped>
.image-input {
}
.mt-1 {
}
.preview {
  margin: 0 0 10px;
  img {
    width: 500px;
  }
}
.image-form {
  background: #eee;
  padding: 15px 15px 10px;
  margin: 0 0 10px;

  h2 {
    margin: 0 0 5px;
    font-size: 13px;
  }
  p.description {
    margin: 0 0 10px;
    color: #aaa;
    font-size: 12px;
  }
  h3 {
    margin: 0 0 5px;
    font-size: 12px;
    color: #666;
  }
}
.upload-preview {
  margin: 10px 0;
}
.form {
  display: flex;
  margin-left: -15px;
  margin-right: -15px;
}
.form-upload {
  flex: 1;
  padding: 0 15px;
}
.form-quote-image {
  flex: 1;
  padding: 0 15px;
}
.image-preview-inner {
  img {
    width: 500px;
  }
}
.image-preview-referer {
  color: #aaa;
  font-size: 1.2rem;
  margin: 5px 0;

  a {
    color: #aaa;
    text-decoration: none;
  }
}
.btn-normal {
  margin-top: 5px;
}
.loading-gif {
  width: 32px;
  height: 32px;
  position: relative;
  top: 12px;
}
</style>

<template>
  <div class="image-input">
    <div class="image-form" v-if="isEditing">
      <h2>画像</h2>
      <div class="preview" v-if="url && url.length">
        <img :src="url" class="img-responsive" />
      </div>
      <p class="description">いずれかの方法で画像を利用して下さい。</p>
      <div class="form">
        <div class="form-upload">
          <h3>ファイルアップロード</h3>
          <img
            v-if="isUploading"
            src="@images/loading.gif"
            class="loading-gif"
          />
          <input type="file" @change="fileSelected($event)" />
        </div>
        <div class="form-quote-image">
          <h3>引用画像</h3>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="画像のURLを入力してください。"
              v-model="quote_url"
            />
            <a @click="check($event)" href="#" class="btn-normal">チェック</a>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-6">
          <label for="">alt</label>
          <input type="text" v-model="alt" class="form-control" />
        </div>
        <div class="col-6">
          <label for="">リンク</label>
          <input type="text" v-model="href" class="form-control" />
        </div>
      </div>
      <div class="btn-group mt-2">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="image-preview input-preview" v-else>
      <div class="image-preview-inner">
        <div class="image-preview-img">
          <img :src="url" class="img-responsive" />
        </div>
        <div class="image-preview-referer">
          引用
          <a :href="quote_url" target="_blank" rel="nofollow">{{
            quote_url
          }}</a>
        </div>
        <div class="image-preview-alt">alt: {{ alt }}</div>
        <div class="image-preview-url">リンク: {{ href }}</div>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  props: {
    index: Number,
    value: {},
    id: String,
  },
  components: {
    'footer-menu': footerMenu,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          url: this.url,
          quote_url: this.quote_url,
          alt: this.alt,
          href: this.href,
          width: this.width,
          height: this.height,
        },
        action: 'image',
        id: this.id,
      };
    },
    valid() {
      return this.url && this.url.length;
    },
  },
  mounted() {
    this.url = this.value.url;
    this.quote_url = this.value.quote_url;
    this.alt = this.value.alt;
    this.href = this.value.href;
    this.width = this.value.width;
    this.height = this.value.height;
  },
  methods: {
    check(e) {
      e.preventDefault();

      $.post({
        url: '/api/image/quote',
        type: 'POST',
        data: {
          url: this.quote_url,
        },
        success: (data) => {
          this.url = data.url;
          this.width = data.width;
          this.height = data.height;
        },
        error: () => {
          alert(
            '無効なURLです。og:image(シェア用の画像リンクの指定)が設定されているURLか、画像URLのみ入力できます'
          );
        },
      });
    },
    fileSelected(e) {
      const files = e.target.files;
      if (!files.length) return;
      const fd = new FormData();

      fd.append('image', files[0]);

      this.isUploading = true;

      $.post({
        url: '/api/image/upload',
        type: 'POST',
        data: fd,
        processData: false,
        contentType: false,
      })
        .then((response) => {
          this.url = response.url;
          this.isUploading = false;
          this.width = response.width;
          this.height = response.height;
        })
        .catch((err) => {
          console.error(err);
          this.isUploading = false;
          alert('アップロードに失敗しました。');
          return false;
        });
    },
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('画像をアップロードしてください。');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
  data() {
    return {
      isEditing: false,
      isUploading: false,
      url: '',
      file: '',
      quote_url: '',
      alt: '',
      href: '',
      width: 0,
      height: 0,
    };
  },
};
</script>
